<template>
    <div class="content_container">
        <el-tabs v-model="activeTab" class="tabs">
            <el-tab-pane label="帐号管理" name="tab1">
                <el-scrollbar>
                    <div class="container">
                        <!-- <div class="filter">
                            <el-form :inline="true"  class="ors_form" label-width="70px">
                                <el-form-item label="团队名称">
                                    <el-input placeholder="请输入名称"></el-input>
                                </el-form-item>
                                <el-form-item label="状态">
                                    <el-select placeholder="请选择状态" :value="1">
                                        <el-option label="启用" value="1"></el-option>
                                        <el-option label="禁用" value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary"><i class="el-icon-search"></i> 查询</el-button>
                                </el-form-item>
                            </el-form>
                        </div> -->
                        <div class="ors_table_nav">
                            <div class="find_applicantNum">
                                <!-- 已选 <span class="condition_number">1</span> 条 -->
                            </div>
                            <div class="operation">
                                <!-- <el-button><i class="el-icon-delete"></i> 批量删除</el-button> -->
                                <!-- <el-button type="primary" @click="AddAccount = true"><i class="el-icon-document-add"></i> 添加</el-button> -->
                                <el-button type="primary" @click="BulkImport = true"><i class="el-icon-download"></i> 导入</el-button>
                            </div>
                        </div>
                        <div class="video_list">
                            <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" class="ors_table">
                                <!-- <el-table-column align="center" :show-overflow-tooltip="true" type="selection" width="50">
                                </el-table-column> -->
                                <el-table-column align="center" :show-overflow-tooltip="true" label="序号" prop='user_child_id' width="60">
                                </el-table-column>
                                <el-table-column align="left" :show-overflow-tooltip="true" label="团队名称" prop='name'>
                                </el-table-column>
                                <el-table-column align="left" :show-overflow-tooltip="true" label="帐号" prop='account' width="200">
                                </el-table-column>
                                <el-table-column align="center" :show-overflow-tooltip="true" label="操作" width="180">
                                    <template slot-scope="scope">
                                        <el-switch v-model="scope.row.status" 
                                            :active-value="1"
                                            :inactive-value="0"
                                            @change="changeAccountStatus($event,scope.row.user_child_id)"
                                        ></el-switch>
                                        <!-- <el-button type="text" size="small" @click="EditAccount = true">编辑</el-button> -->
                                        <el-button type="text" size="small" @click="deleteAccount(scope.row.user_child_id)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="paginate">
                            <el-pagination
                                layout="prev, pager, next"
                                :hide-on-single-page="true"
                                @current-change="clickPage"
                                :total="total">
                            </el-pagination>
                            </div>
                        </div>
                    </div>
                </el-scrollbar>
            </el-tab-pane>
        </el-tabs>
        <!-- 批量导入 -->
		<el-dialog custom-class="ors_tc" title="批量导入" :visible.sync="BulkImport" width="480px">
		    <el-form ref="form" :model="add">
		        <el-form-item>
		        	<div class="ors_upload">
						<div class="upload_tip">
                            请选择CSV或EXCEL格式的文件（<a :href="downloadTemplateUrl">参考示例模板</a>）
                        </div>
                        <el-upload
                            class="upload_box flex"
                            ref="upload"
                            :action="uploadExcelUrl"
                            :limit="1"
                            :headers="uploadHeaders"
                            :file-list="importList"
                            :on-success="importSuccess"
                            :auto-upload="false">
                            <div class="operate-btn">
                                <el-button slot="trigger" size="small">浏览</el-button>
                                <!-- <el-button style="margin-left: 10px;" size="small" type="primary" @click="submitUpload">上传</el-button> -->
                            </div>
                        </el-upload>
                    </div>
                </el-form-item>
			</el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button size="small" @click="BulkImport = false">取 消</el-button>
		        <el-button size="small" type="primary" @click="uploadHandle">导入</el-button>
		    </span>
		</el-dialog>

		<!-- 添加账号 -->
		<el-dialog custom-class="ors_tc" title="添加账号" :visible.sync="AddAccount" width="480px">
		    <el-form ref="form" :model="add" label-width="70px">
		        <el-form-item label="团队名称">
				    <el-input type="text" v-model="add.title"></el-input>
				</el-form-item>
		        <el-form-item label="帐号">
				    <el-input type="text" v-model="add.account"></el-input>
				</el-form-item>
		        <el-form-item label="密码">
				    <el-input type="password" v-model="add.password" :show-password='true'></el-input>
				</el-form-item>
		        <el-form-item label="状态">
				   	<el-switch v-model="add.isOpen"></el-switch>
				</el-form-item>
			</el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button size="small" @click="AddAccount = false">取 消</el-button>
		        <el-button size="small" type="primary" @click="AddAccount = false">复制</el-button>
		    </span>
		</el-dialog>

    </div>
</template>

<script>
export default {
    name:'Account',
    data(){
        return {
            activeTab: 'tab1', //当前tab

            AddAccount: false, //添加帐号
            BulkImport: false, //批量导入
            EditAccount: false, //编辑帐号
            uploadExcelUrl:process.env.VUE_APP_API_URL + '/api/accountImport',
            uploadHeaders:{Authorization:window.localStorage.getItem('token')},
            downloadTemplateUrl:process.env.VUE_APP_API_URL + '/muban.xlsx',
            page:1,
            pagesize:10,
            total:0,
            tableData:[],
            // 筛选
            search: {
                program: '',
                batch: '',
                name: '',
                isOpen: '',
            },


            add:{
                title: '',
                account: '',
                password: '',
                isOpen: false,
            },

            edit:{
                title: '上海小分队',
                account: 'admin',
                password: '123456',
                isOpen: true
            },

            importList: [],
        }
    },
    mounted(){
        this.getAccounts();
    },
    methods:{
       getAccounts(){
            let param = this.search;
            let that = this;
            param['page'] = this.page;
            param['pagesize'] = this.pagesize;

            this.$API('/api/childAccountList','get',param,function(response){
                if(response.code === 200){
               
                that.tableData = response.data.data;
                that.total=response.data.total;
                }
            });
        },
        uploadHandle(){
            this.$refs.upload.submit();
        },
        importSuccess(response){
            if(response.code === 200){
                this.$ok('导入成功');
                this.getAccounts();
                this.BulkImport=false;
                this.$refs.upload.clearFiles();
            }else{
                this.$ok('导入失败');
            }
        },
        clickPage(n){
            this.page = n;
            this.getAccounts();
        },
        deleteAccount(id){
            this.$confirm('确认删除该账号？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                let that = this;
                this.$API('/api/childAccountDel','post',{id:id},function(response){
                    if(response.code === 200){
                        that.$ok(response.message);
                        that.getAccounts();
                    }else{
                        that.$error(response.message);
                    }
                });
            }).catch(() => {});
        },
        changeAccountStatus(e,id){
            let that = this;
            this.$API('/api/childAccountStatus','post',{id:id,status:e},function(res){
                if(res.code === 200){
                    that.$ok((e==1 ? '启用':'禁用')+'成功');
                }
            });
        }
    }
}
</script>
<style>
  .paginate{
    float:right;
  }
</style>